/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Agents_Resource_Guide_TitleInputs */

const en_directory_agents_resource_guide_title = /** @type {(inputs: Directory_Agents_Resource_Guide_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Agent guide`)
};

const zh_directory_agents_resource_guide_title = /** @type {(inputs: Directory_Agents_Resource_Guide_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Agent 指引`)
};

/**
* | output |
* | --- |
* | "Agent guide" |
*
* @param {Directory_Agents_Resource_Guide_TitleInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_agents_resource_guide_title = /** @type {((inputs?: Directory_Agents_Resource_Guide_TitleInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Agents_Resource_Guide_TitleInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_agents_resource_guide_title(inputs)
	return zh_directory_agents_resource_guide_title(inputs)
});
export { directory_agents_resource_guide_title as "directory.agents.resource_guide_title" }